import '../Home/HomePage.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer">
      <p>
        © {currentYear} Meicor. Todos os direitos reservados. Feito com muito amor por{' '}
        <a href="https://www.linkedin.com/in/jos%C3%A9-pedro-meireles-alves-783a9994/" target="_blank" rel="noopener noreferrer">
          José Meireles
        </a>. ❤️
      </p>
    </footer>
  );
};

export { Footer };
